var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  device: function device(state) {
    return state.app.device;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.userInfo.avatar;
  },
  name: function name(state) {
    return state.user.userInfo.staffName;
  },
  staffCode: function staffCode(state) {
    return state.user.staffCode;
  },
  routes: function routes(state) {
    return state.permission.routes;
  }
};
export default getters;